import {injectable} from "inversify"
import {Tenjin} from 'ionic-capacitor-tenjin';

@injectable()
export class TenjinService {

    async initTenjin() {
        console.log("Tenjin: try to init");
        await Tenjin.initialize({ sdkKey: process.env.VUE_APP_TENJIN_SDK_KEY })
        console.log("Tenjin: success init");
    }

    async transaction(productName: string, currencyCode: string, quantity: number, unitPrice: number) {
        console.log(`Tenjin: try to send transaction: {productName:${productName}, currencyCode:${currencyCode}, quantity:${quantity}, unitPrice:${unitPrice}`);
        await Tenjin.transaction({productName: productName, currencyCode: currencyCode, quantity: quantity, unitPrice: unitPrice})
        console.log("Tenjin: success transaction");
    }

    async connectTenjin() {
        console.log("Tenjin: try to connect");
        await Tenjin.connect()
        console.log("Tenjin: success connect");
    }

    async optIn() {
        console.log("Tenjin: try to optIn");
        await Tenjin.optIn()
        console.log("Tenjin: success optIn");
    }

    async optOut() {
        console.log("Tenjin: try to optOut");
        await Tenjin.optOut()
        console.log("Tenjin: success optOut");
    }

    async sendEvent() {
        await Tenjin.eventWithName({ name: "Event" })
    }

    async updatePostback() {
        await Tenjin.updatePostbackConversionValueCoarseValueLockWindow({ conversionValue: 2, coarseValue: "medium", lockWindow: true })
    }

    async setCustomerUserId() {
        await Tenjin.setCustomerUserId({ userId: "test_ionic_user_id" })
    }

    async getCustomerUserId() {
        let userId = await Tenjin.getCustomerUserId()
        console.log(userId)
    }

    async attributionInfo() {
        let attributionInfo = await Tenjin.getAttributionInfo()
        console.log(attributionInfo)
    }

    async sendImpression() {
        await Tenjin.eventAdImpressionAppLovin({ json: {
                "format": "Banner",
                "revenue_precision": "exact",
                "ad_unit_id": "1394580265a9af9b",
                "network_placement": "banner_regular",
                "placement": "",
                "publisher_revenue_decimal": "0",
                "ad_revenue_currency": "USD",
                "revenue": "0",
                "creative_id": "6146419",
                "publisher_revenue_micro": "0",
                "network_name": "AppLovin"
            }})
    }


}
